import "./AutomationEcosystem.module.css";
import Header from "@/reusable_sections/Header";
import Expertise from "./sections/Expertise";
import Automation from "./sections/Automation";
import Inquiries from "./sections/Inquiries";
import Footer from "@/reusable_sections/Footer";
export default function AutomationEcosystemPage() {
  return <div>
      <Header />
      <Expertise />
      <Automation />
      <Inquiries />
      <Footer />
    </div>;
}